<template>
  <div class="menu blue-menu" :class="{'smart-phone-close': selectroom.name != ''}">
    <b-modal width="680px" :active.sync="isShowBilling">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            従量課金プラン - 上限超過
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
              現在従量課金プランの上限を超過している関係上、<br>
              会話内容を閲覧することができません。<br>
              下記ボタンより、上限設定の変更をお願い致します。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isShowBilling=false">閉じる</a>
          <a class="card-footer-item" @click="$router.push('/client/setting/billing')">上限設定変更画面へ</a>
        </footer>
      </div>
    </b-modal>
    <div class="tabs tabs-list is-toggle is-centered">
      <ul style="font-size: 12.7px; border-bottom: none !important; border-radius: 5px;">
        <li :class="{'is-active': isTalkList}">
          <a style="padding-left: 7px; padding-right: 7px;" @click="isTalkList=true;isProgressList=false;isContactList=false;" class="is-tab-list">
            <span
              v-if="roomcount > 0"
              class="tag is-danger is-rounded is-normal"
              style="transform: scale(0.8); position: absolute; top: -7px; left: 45px; z-index: 1000;">
              {{roomcount}}
            </span>
            <span class="mdi mdi-format-list-bulleted" style="margin-right: 7px;"></span>
            一覧
          </a>
        </li>
        <li :class="{'is-active': isProgressList}">
          <a style="padding-left: 5px; padding-right: 5px;" @click="isTalkList=false;isProgressList=true;isContactList=false;" class="is-tab-list back-on-hover">
            <span class="mdi mdi-check-circle-outline"></span>
            会話済
          </a>
        </li>
        <li :class="{'is-active': isContactList}">
          <a style="padding-left: 5px; padding-right: 5px;" @click="isTalkList=false;isProgressList=false;isContactList=true;" class="is-tab-list">
            <span class="mdi mdi-account-circle"></span>
            応募済
          </a>
        </li>
      </ul>
    </div>
    <div style="height: 35px; width: 100%; padding: 8px; padding-top: 0;">
      <input class="input is-small" placeholder="🔎訪問者名で検索" v-model="searchName"/>
    </div>
    <transition name="fade">
      <div class="list-container scroll-box-sub disp-scroll" @scroll="infiniteLoad" v-if="isTalkList">
        <ul class="menu-list" v-if="Object.keys(roomlist.active).length > 0">
          <li v-for="(room, indexAA) in roomlist.active" :key="indexAA" v-if="(!searchName || searchName && room.skname.indexOf(searchName) >= 0)">
            <div class="dot-line"></div>
            <template
              v-if="user.billing === 3
                    && (payperuseInfoData.sum_pay_per_use > user.upper_price)
                    && room.updatedAt >= payperuseInfoData.overflow_date
              ">
              <div
                @click="isShowBilling = true"
                class="white-menu hovar-list billing-msg">
                <p>訪問者●●●</p>
                <p style="color: #666;">
                  課金された料金の上限を超えております。<br>
                  クリックで上限設定の見直しをお願いします。
                </p>
              </div>
            </template>
            <template v-else>
              <div @click="selectRoom(room)" class="hovar-list" :class="{'click-list': room.name == clicked}">
                <div class="reflection" v-if="room.newMessage > 0"></div>
                <div class="white-menu">
                  <span class="new-message" v-if="room.newMessage > 0">{{room.newMessage}}</span>
                  <span class="isOnline" v-if="room.isOnline==='1' && roomcount > 0"></span>
                  <span class="isOffline" v-else></span>
                  <div class="name">
                    <p>
                      <span class="mdi mdi-circle-edit-outline" v-if="room.talk === 1"></span>
                      <span v-if="!room.clickedIcon"></span>
                      {{ room.skname }}
                    </p>
                  </div>
                </div>
                <div class="seeker-info">
                  訪問日時
                  <span style="margin-left: 3px;" v-if="!isNaN(new Date(room.updatedAt))">{{ inviteTime(new Date(room.updatedAt)) }}</span>
                  <span style="margin-left: 3px;" v-else> {{ inviteTime(new Date(room.updatedAt.replace(/-/g, '/').substring(0, 17) + room.updatedAt.substring(25, 29))) }} </span>
                </div>
                <b-collapse class="panel" style="box-shadow: none;" open.sync="false">
                  <div class="to-info">
                    <p v-if="room.target !== 'no target'"><span class="tag is-normal" :class="{'is-link': room.target !== user.username, 'is-danger': room.target === user.username}">宛先: {{name(room.target)}}</span></p>
                  </div>
                  <div class="to-info">
                    <p v-if="room.isOmit"><span class="tag is-normal">カウント除外対象</span></p>
                  </div>
                </b-collapse>
              </div>
            </template>
          </li>
        </ul>
        <ul class="menu-list">
          <li v-for="(room, indexAS) in roomlist.search" :key="indexAS" v-if="(!searchName || searchName && room.skname.indexOf(searchName) >= 0)">
            <div class="dot-line" v-if="isConnected(room)"></div>
            <template
              v-if="user.billing === 3
                    && (payperuseInfoData.sum_pay_per_use > user.upper_price)
                    && room.updatedAt >= payperuseInfoData.overflow_date
              ">
              <div
                @click="isShowBilling = true"
                class="white-menu hovar-list billing-msg" v-if="isConnected(room)">
                <p>訪問者●●●</p>
                <p style="color: #666;">
                  課金された料金の上限を超えております。<br>
                  クリックで上限設定の見直しをお願いします。
                </p>
              </div>
            </template>
            <template v-else>
              <div @click="selectRoom(room)" class="hovar-list" :class="{'click-list': room.name == clicked}" v-if="isConnected(room)">
                <div class="reflection" v-if="room.newMessage > 0"></div>
                <div class="white-menu">
                  <span class="new-message" v-if="room.newMessage > 0">{{room.newMessage}}</span>
                  <span class="isOffline"></span>
                  <div class="name">
                    <p>
                      <span v-if="!room.clickedIcon"></span>
                      {{ room.skname }}
                    </p>
                  </div>
                </div>
                <div class="seeker-info">
                  訪問日時
                  <span style="margin-left: 3px;" v-if="!isNaN(new Date(room.updatedAt))">{{ inviteTime(new Date(room.updatedAt)) }}</span>
                  <span style="margin-left: 3px;" v-else> {{ inviteTime(new Date(room.updatedAt.replace(/-/g, '/').substring(0, 17) + room.updatedAt.substring(25, 29))) }} </span>
                </div>
                <b-collapse class="panel" style="box-shadow: none;" open.sync="false">
                  <div class="to-info">
                    <p v-if="room.target !== 'no target'"><span class="tag is-normal" :class="{'is-link': room.target !== user.username, 'is-danger': room.target === user.username}">宛先: {{name(room.target)}}</span></p>
                  </div>
                  <div class="to-info">
                    <p v-if="room.isOmit"><span class="tag is-normal">カウント除外対象</span></p>
                  </div>
                </b-collapse>
              </div>
            </template>
          </li>
        </ul>
        <div v-if="isScrollLoading && isCompanyDataLoading"><span class="mdi mdi-loading mdi-48px mdi-spin mdi-light"></span></div>
      </div>
    </transition>
    <transition name="fade">
      <div class="list-container disp-scroll" v-if="isProgressList">
        <ul class="menu-list">
          <li v-for="(room, indexB) in roomlist.all" :key="indexB" v-if="(!searchName || searchName && room.skname.indexOf(searchName) >= 0)">
            <div class="dot-line" v-if="makeProgress(room) > 0"></div>
            <template
              v-if="user.billing === 3
                    && (payperuseInfoData.sum_pay_per_use > user.upper_price)
                    && room.updatedAt >= payperuseInfoData.overflow_date
              ">
              <div
                @click="isShowBilling = true"
                class="white-menu hovar-list billing-msg">
                <p>訪問者●●●</p>
                <p style="color: #666;">
                  課金された料金の上限を超えております。<br>
                  クリックで上限設定の見直しをお願いします。
                </p>
              </div>
            </template>
            <template v-else>
              <div @click="selectRoom(room)" class="hovar-list" :class="{'click-list': room.name == clicked}" v-if="makeProgress(room) > 0">
                <div class="reflection" v-if="room.newMessage > 0"></div>
                <div class="white-menu">
                  <div class="name">
                    <p style="width: 130px; overflow: hidden; text-align: left;">
                      <span v-if="!room.clickedIcon"></span>
                      {{ room.skname }}
                    </p>
                    <a class="star-location" v-if="!room.star" @click="setStar(room, indexB)"><span class="mdi mdi-star-outline"></span></a>
                    <a class="star-location" v-if="room.star" @click="setStar(room, indexB)"><span class="mdi mdi-star"></span></a>
                  </div>
                </div>
                <div class="seeker-info">
                  訪問日時
                  <span style="margin-left: 3px;" v-if="!isNaN(new Date(room.updatedAt))">{{ inviteTime(new Date(room.updatedAt)) }}</span>
                  <span style="margin-left: 3px;" v-else> {{ inviteTime(new Date(room.updatedAt.replace(/-/g, '/').substring(0, 17) + room.updatedAt.substring(25, 29))) }} </span>
                </div>
                <b-collapse class="panel" style="box-shadow: none;" open.sync="false">
                  <div class="to-info">
                    <p v-if="room.target !== 'no target'"><span class="tag is-normal" :class="{'is-link': room.target !== user.username, 'is-danger': room.target === user.username}">宛先: {{name(room.target)}}</span></p>
                  </div>
                  <div class="to-info">
                    <p v-if="room.isOmit"><span class="tag is-normal">カウント除外対象</span></p>
                  </div>
                </b-collapse>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </transition>
    <transition name="fade">
      <div class="list-container disp-scroll" v-if="isContactList">
        <ul class="menu-list">
          <li v-for="(room, indexC) in roomlist.star" :key="indexC" v-if="(!searchName || searchName && room.skname.indexOf(searchName) >= 0)">
            <div class="dot-line"></div>
            <template
              v-if="user.billing === 3
                    && (payperuseInfoData.sum_pay_per_use > user.upper_price)
                    && room.updatedAt >= payperuseInfoData.overflow_date
              ">
              <div
                @click="isShowBilling = true"
                class="white-menu hovar-list billing-msg">
                <p>訪問者●●●</p>
                <p style="color: #666;">
                  課金された料金の上限を超えております。<br>
                  クリックで上限設定の見直しをお願いします。
                </p>
              </div>
            </template>
            <template v-else>
              <div @click="selectRoom(room)" class="hovar-list" :class="{'click-list': room.name == clicked}">
                <div class="reflection" v-if="room.newMessage > 0"></div>
                <div class="white-menu">
                  <div class="name">
                    <p>
                      <!-- <span class="mdi mdi-eye-outline mdi-light" style="transform: scale(1.5);" v-if="room.clickedIcon"></span> -->
                      <span v-if="!room.clickedIcon"></span>
                      {{ room.skname }}
                    </p>
                  </div>
                </div>
                <div class="seeker-info">
                  訪問日時
                  <span v-if="!isNaN(new Date(room.updatedAt))">{{ inviteTime(new Date(room.updatedAt)) }}</span>
                  <span v-else> {{ inviteTime(new Date(room.updatedAt.replace(/-/g, '/').substring(0, 17) + room.updatedAt.substring(25, 29))) }} </span>
                </div>
                <b-collapse class="panel" style="box-shadow: none;" open.sync="false">
                  <div class="to-info">
                    <p v-if="room.target !== 'no target'"><span class="tag is-normal" :class="{'is-link': room.target !== user.username, 'is-danger': room.target === user.username}">宛先: {{name(room.target)}}</span></p>
                  </div>
                  <div class="to-info">
                    <p><span class="tag is-normal">{{ name( makeProgressTag(room) ) }}</span></p>
                  </div>
                  <div class="to-info">
                    <p v-if="room.isOmit"><span class="tag is-normal">カウント除外対象</span></p>
                  </div>
                </b-collapse>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DirectTalkSubMenu',
  components: {
  },  
  componentName: 'DirectTalkSubMenu',
  data () {
    return {
      selectList: [
        '一覧',
        '会話済',
        '応募済'
      ],
      isTagActive: true,
      isDirector: false,
      isBot: false,
      isPerson: false,
      isStarList: false,
      isUp: false,
      isDown: false,
      clicked: null,
      isTalkList: true,
      isProgressList: false,
      isContactList: false,
      searchName: '',
      num: 1,
      isShowBilling: false
    }
  },
  computed: {
    ...mapState('auth', ['user', 'botstatus', 'query_url_direct', 'payperuseInfoData']),
    ...mapState('directtalk', ['roomlist', 'chatData', 'isConnectRoom', 'selectroom', 'roomcount', 'isReadRoom', 'messagePages', 'isScrollLoading', 'isCompanyDataLoading'])
  },
  mounted () {
    console.debug('*** Start *** mounted')
    console.log('=========')
    console.log(this.roomlist.search)
    console.log(this.roomlist.query)
    console.log('query_url_direct',this.query_url_direct)
    console.log('aiaiai',this.roomlist.query.length)
    if  (this.query_url_direct == null){
      console.info('query_url_direct is null')
          //処理をしない
    }else{
      console.info('query_url_direct is not null')
      this.getallroom(this.query_url_direct)
      this.$store.dispatch('auth/getQueryDelet','direct')
    }
    console.debug('*** End *** mounted')
  },
  methods: {
    getallroom(url){
      console.debug('*** Start *** getallroom')
      console.debug('url: ' + JSON.stringify(url))
      var search = {
        'get_type': 'query',
        'query_url_direct': url
      }
      this.$store.dispatch('directtalk/getRoomList', search)
      console.debug('*** End *** getallroom')
    },
    selectRoom (data) {
      console.debug('*** Start *** selectRoom')
      console.debug('data: ' + JSON.stringify(data))
      this.clicked = data.name
      if (this.isConnectRoom) {
        console.debug('isConnectRoom is true')
        this.$store.dispatch('directtalk/disconnect')
      }
      console.log('list_select: ' + JSON.stringify(data))
      this.$store.dispatch('directtalk/selectRoom', data)
      this.$store.dispatch('directtalk/getUrlList', data)
      this.$store.dispatch('directtalk/getCompanyData', this.selectroom)
      var uri = process.env.WS_ENDPOINT + this.user.companyID + '/' + data.name + '/'
      console.log('DashBoard InputForm WS:' + uri)
      // this.$router.push('/dashboard/directtalk'+'?code='+data.skname)
      this.$store.dispatch('directtalk/connect', {uri: uri, category: 'managementtool'})
        .then(() => this.$store.dispatch('directtalk/getMessage', {name: 'manager', pages: this.messagePages}))
      var vm = this
      setTimeout(function () {
        var rand = Math.floor(Math.random() * 9)
        vm.chatData.icon = process.env.API_ENDPOINT + '/img_s/icon/' + rand + '.png'
        console.log('icon_uri: ' + vm.chatData.icon)
        var uriSpeaker = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : process.env.WDT_ENDPOINT
        uriSpeaker += '/dashboard/directtalk'
        vm.$store.dispatch('directtalk/setManager', uriSpeaker)
      }, 200)
      // alert(JSON.stringify(data))
      // モバイルの場合はそのままチャット画面に遷移する   
      if (window.innerWidth <= 480) this.$emit('changeView')
      console.debug('*** End *** selectRoom')
    },
    inviteTime (time) {
      return time.getMonth() + 1 + '/' + time.getDate() + ' ' + time.getHours() + ':' + ('00' + time.getMinutes()).slice(-2)
    },
    readSearchList () {
      console.debug('*** Start *** readSearchList')
      this.num++
      console.log(this.num)
      var search = {
        'get_type': 'search',
        'limit': this.num
      }
      this.$store.dispatch('directtalk/getRoomList', search)
      console.debug('*** End *** readSearchList')
    },
    makeProgressTag (room) {
      console.debug('*** Start *** makeProgressTag')
      console.debug('room: ' + JSON.stringify(room))
      if (room.subscribe && room.subscribeAction) return '対応済'
      else if (room.subscribe && !room.subscribeAction) return '未対応'
      else if (room.star) return '対応済'
      else return '未対応'
    },
    name (n) {
      return n.length < 13 ? n : n.substring(0, 11) + '...'
    },
    isConnected (room) {
      var flg = true
      if (this.roomlist.active) {
        for (var index in this.roomlist.active) {
          if (room.name === this.roomlist.active[index].name) flg = false
        }
      }
      return flg
    },
    makeProgress (room) {
      console.debug('*** Start *** makeProgress')
      console.debug('room: ' + JSON.stringify(room))
      var param = 0
      if (room.target !== 'no target') param++
      if (room.readTime !== 'None') param++
      if (room.isMessage) param++
      console.debug('param: ' + param)
      console.debug('*** End *** makeProgress')
      return param
    },
    setStar (room, index) {
      console.debug('*** Start *** setStar')
      console.debug('room: ' + JSON.stringify(room))
      console.debug('index: ' + JSON.stringify(index))
      var data = {
        'name': room.name,
        'group': room.group,
        'star': !room.star
      }
      this.$store.dispatch('directtalk/setStar', {data: data, index: index})
      this.$buefy.toast.open({
        message: !room.star ? '応募済リストに追加しました！' : '応募済リストから解除しました！',
        type: 'is-success',
        position: 'is-top'
      })
      console.debug('*** End *** setStar')
    },
    infiniteLoad () {
      console.debug('*** Start *** infiniteLoad')
      if (this.roomlist.search[this.roomlist.search.length - 1].skname != '訪問者1') {
        var target = document.querySelector('div.scroll-box-sub')
        if ((target.scrollHeight - target.clientHeight)-target.scrollTop < 5 && !this.isScrollLoading) this.readSearchList()
      }
      console.debug('*** End *** infiniteLoad')
    }
  },
  watch: {
    isConnectRoom: function () {
      if (!this.isConnectRoom) {
        var uri = process.env.WS_ENDPOINT + this.user.companyID + '/' + this.selectroom.name + '/'
        this.$store.dispatch('directtalk/connect', {uri: uri, category: 'managementtool'})
      }
    },
    query_url_direct : function(){
      if (this.query_url_direct != null){
        this.getallroom(this.query_url_direct)
        this.$store.dispatch('auth/getQueryDelet','direct')
      }    
    },
    'roomlist.query' () {
      this.selectRoom (this.roomlist.query[0])
    },
    isScrollLoading () {
      if (this.isScrollLoading) {
        this.$buefy.toast.open({
          message: '過去の訪問者情報を読み込み中です',
          type: 'is-primary',
          position: 'is-bottom'
        })
      }
    }
  }
}
</script>

<style scoped>
.read {
  color: yellow;
}
hr {
  height: 1px !important;
}
.blue-menu {
  width: 200px;
  background: #fefefe;
  height: 100vh;
  border-right: solid thin #ccc;
}
.tabs-list {
  margin-bottom: 0;
  padding: 7.5px;
  color: #222;
}
.tabs-list:hover {
  color: #fefefe;
}

.is-tab-list {
  position: relative;
  color: #222;
}
.is-tab-list:hover {
  color: #FEFEFE;
}
a.back-on-hover:hover {
  z-index: 0;
}

.list-container {
  //overflow-x: hidden;
  //overflow-y: scroll;
  height: calc(100vh - 85px);
  width: 100%;
}

.list-container::-webkit-scrollbar {
  //width:  5px !important;
  //height: 5px !important;
  //visibility: visible !important;
}

.title-menu {
  display: flex;
  justify-content: left;
  padding-top: 10px;
  padding-left: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #FFF !important;
  margin: 0px !important;
}

.menu-list {
  font-size: 15px;
}

.white-menu {
  position: relative;
  display: flex;
  justify-content: left;
  border: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 14px;
  width: 100%;
}

.hovar-list {
  position: relative;
  padding: 16px;
  cursor: pointer;
}

.hovar-list:hover {
  position: relative;
  background-color:rgba(240, 200, 200, 0.8);
}

.click-list {
  background-color:rgba(240, 200, 200, 0.8);
}

.name {
  display: flex;
  position: relative;
  justify-content: left;
  padding-left: 10px;
  width: 185px;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.isOnline {
  float: left;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: greenyellow;
  margin-top: 3px;
}
.isOffline {
  float: left;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: solid thin #CCC;
  background: transparent;
  margin-top: 3px;
}
.button-director {
  color: #F8F8F8;
  margin-top: 5px;
  margin-left: 20px;
  font-size: 14px;
  text-align: left;
}
.seeker-info {
  display: flex;
  justify-content: left;
  color: #666;
  margin-top: 5px;
  margin-left: 20px;
  font-size: 13px;
  text-align: left;
}
.to-info {
  display: flex;
  justify-content: left;
  color: #F8F8F8;
  margin-top: 5px;
  font-size: 13x;
  text-align: left;
  margin-left: 20px;
}
.new-message {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  right: 0;
  top: -8px;
  border-radius: 50%;
  color: #fff;
  line-height: 20px;
  font-size: 11px;
  z-index: 2;
  background: #eb464e;
}
.billing-msg {
  flex-direction: column;
  text-align: left;
}
.star-location {
  position: absolute;
  padding: 0;
  left: 143px;
  color: #666;
  transform: scale(1.5);
  z-index: 100;
}
.star-location:hover {
  color: yellow;
  background: transparent;
}
.dot-line {
  height: 10px;
  width: calc(100% - 24px);
  margin-left: 12px;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
}
@media screen and (max-width: 400px) {
  .blue-menu {
    width: 100%;
    background-color: rgb(55, 55, 55) !important;
    height: 100%;
  }
}

.fade-enter-active {
  transition: opacity .5s, transform .5s;
}
.fade-enter {
  opacity: 0;
  transform: translateY(20px);
}

/* ピカピカひかるアニメーション（リスト用） */
.reflection {
    height      :100%;
    width       :100%;
    position    :absolute;
    top         :0;
    left        :0;
    background-color: #fff;
    opacity     :0;
    animation:         reflection 1s ease-in-out infinite;
    -webkit-animation: reflection 1s ease-in-out infinite;
    -moz-animation:    reflection 1s ease-in-out infinite;
    -ms-animation:     reflection 1s ease-in-out infinite;
    -o-animation:      reflection 1s ease-in-out infinite;
}

@keyframes reflection {
  0%   { opacity: 0; }
  50%  { opacity: 0.3; }
  100% { opacity: 0; }
}
@-webkit-keyframes reflection {
  0%   { opacity: 0; }
  50%  { opacity: 0.3; }
  100% { opacity: 0; }
}
@-moz-keyframes reflection {
  0%   { opacity: 0; }
  50%  { opacity: 0.3; }
  100% { opacity: 0; }
}
@-ms-keyframes reflection {
  0%   { opacity: 0; }
  50%  { opacity: 0.3; }
  100% { opacity: 0; }
}
@-o-keyframes reflection {
  0%   { opacity: 0; }
  50%  { opacity: 0.3; }
  100% { opacity: 0; }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DirectTalk/DirectTalkSubMenu.vue